import { IWordBank } from 'types'

export default class WordBankSelectService {
  static getSubTypes(wordBanks = [] as IWordBank[]) {
    return wordBanks.reduce((acc, word) => {
      if (!acc.includes(word.subType)) {
        acc.push(word.subType)
      }
      return acc
    }, [])
  }
}
